import { render, staticRenderFns } from "./KnownLanguagesConf.vue?vue&type=template&id=f2906fa6"
import script from "./KnownLanguagesConf.vue?vue&type=script&lang=js"
export * from "./KnownLanguagesConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports